import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MainApp } from './components/MainApp'
import './index.css'
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from '@vercel/analytics/react'
import * as Sentry from "@sentry/react";
import { ApiClient } from './api/client'
import { AppProvider } from './contexts/AppContext'
import { WebAppProvider } from './webAppContext'
import { ThemeProvider } from './components/ThemeProvider'
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import './i18n'; // Import to initialize i18next
import { initializeTelegramAnalytics } from './utils/telegramAnalytics';


// Extract hostname from API URL
const apiUrl = new URL(import.meta.env.VITE_API_URL).hostname;

Sentry.init({
  dsn: "https://45f4efb178fc39f8b68affbaf815bc38@o4505937579802624.ingest.us.sentry.io/4508873583558656",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", apiUrl],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Initialize impersonation status from sessionStorage
ApiClient.initializeImpersonation();

// Initialize Telegram Analytics
initializeTelegramAnalytics();

// Initialize the app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <WebAppProvider>
      <ThemeProvider>
        <AppProvider>
          <I18nextProvider i18n={i18n}>
            <BrowserRouter>
              <MainApp />
            </BrowserRouter>
          </I18nextProvider>
        </AppProvider>
      </ThemeProvider>
    </WebAppProvider>
    <SpeedInsights />
    <Analytics />
  </React.StrictMode>,
)